import './LegendWithGrouping.scss';
import { ReactNode } from 'react';
import { MdOutlineWarningAmber } from 'react-icons/md';
import { Neutral200 as INACTIVE_COLOR } from '../../../utils/colors';
import { InteractiveDiv } from '../../InteractiveEl';

interface LegendWithGroupingProps {
  activeArea: string | null;
  activeGroup: string | null;
  handleLegendClick: (area: string, group?: string) => void;
  setHoveredLegend: React.Dispatch<React.SetStateAction<string | null>>;
  handleLegendEnter: (area: string) => void;
  hoveredLegend: string | null;
  incrementality?: boolean;
  colorMap: any;
  groupedAreas: any;
  className?: string;
  showDash?: boolean;
  svg?: ReactNode;
}

export const LegendWithGrouping = ({
  activeArea,
  activeGroup,
  handleLegendClick,
  setHoveredLegend,
  handleLegendEnter,
  hoveredLegend,
  incrementality,
  colorMap,
  groupedAreas,
  className,
  showDash = false,
  svg
}: LegendWithGroupingProps): ReactNode =>
  groupedAreas.map((group, groupIndex) => (
    <div key={`group-${groupIndex}`} className='legend-with-grouping'>
      <div className='legend-item'>
        <div className='legend-value'>
          <div>
            <div className='legend-header-wrapper' style={{ cursor: 'default' }}>
              <div
                className={`legend-header ${
                  activeGroup === group.channel || activeGroup === null ? '' : 'inactive-legend'
                }`}
              >
                {group.channel}
              </div>
            </div>
            {group.areas.map((area, areaIndex) => {
              const isActiveArea = activeArea === null ? true : activeArea === area.name;
              const isHoveredLegend = hoveredLegend === null ? true : hoveredLegend === area.name;
              const activeColor = isActiveArea ? colorMap?.[area.name] : INACTIVE_COLOR;
              const hoverColor = isHoveredLegend ? colorMap?.[area.name] : INACTIVE_COLOR;
              return (
                <InteractiveDiv
                  key={`area-${groupIndex}-${areaIndex}`}
                  className='sub-header-wrapper'
                  onClick={() => handleLegendClick(area.name, group.channel)}
                  onMouseEnter={() => handleLegendEnter(area.name)}
                  onMouseLeave={() => setHoveredLegend(null)}
                >
                  {activeArea === area.name && svg ? (
                    <div className='legend-icon'>
                      <svg viewBox='0 0 16 12' preserveAspectRatio='none'>
                        {svg}
                      </svg>
                    </div>
                  ) : (
                    <div
                      className={`square ${showDash ? 'dash' : ''}  ${
                        className || ''
                      } ${isActiveArea ? 'active' : ''}`}
                      style={{
                        backgroundColor: `${activeArea ? activeColor : hoverColor}`
                      }}
                    />
                  )}
                  <div className='sub-header-text-wrap'>
                    <div className={`sub-header-1 ${isActiveArea ? '' : 'inactive-legend'}`}>
                      {area.grouping.platform}
                    </div>
                    {area.grouping.platform &&
                      (area.grouping.tactic || area.grouping.brand_nonbrand) && (
                        <div style={{ whiteSpace: 'pre-wrap' }}> – </div>
                      )}
                    <div className={`sub-header-2 ${isActiveArea ? '' : 'inactive-legend'}`}>
                      {`${area.grouping.tactic ? area.grouping.tactic : ''}${
                        area.grouping.tactic && area.grouping.brand_nonbrand ? ', ' : ''
                      }${area.grouping.brand_nonbrand ? area.grouping.brand_nonbrand : ''}`}
                    </div>
                    {area.incrementality && incrementality && (
                      <MdOutlineWarningAmber
                        style={{
                          color: isActiveArea || activeArea === null ? 'orange' : INACTIVE_COLOR,
                          marginLeft: '5px'
                        }}
                      />
                    )}
                  </div>
                </InteractiveDiv>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  ));
